import { get } from "lodash";
import PropTypes from "prop-types";
import { memo } from "react";
import { useDispatch, useSelector } from "react-redux";
import { setSelectedDdMenuValue } from '../../commonSlice.js';
import CustomOffCanvas from '../CustomOffCanvas.jsx';
import Dropdown from './Dropdown.jsx';
import "./features.common.styles.scss";

const EmptyDrillDownOffCanvas = (props) => {
  const offcanvasState = useSelector((state) => state.common?.offcanvasState);
  const commonSliceState = useSelector((state) => state.common);
  const selectedData = get(commonSliceState, "offcanvasState.selectedData", []);
  console.log('selectedData: ', selectedData);
  const dispatch = useDispatch();

  return (
    <CustomOffCanvas className="custom-off-canvas">
      <div
        className={
          props.customClass
            ? props.customClass
            : ""
        }
      >
      {((offcanvasState?.title || props.subHeading) && (
        <h3 className="flowhead">
          {offcanvasState?.title}
          {props.subHeading && <span>{props.subHeading} </span>}
          {offcanvasState?.title && props.subHeading && <span> {props.subHeading}</span>}
        </h3>
      ))}
        {offcanvasState?.dropDownMenuOptions && (
          <div className="flowact-nav">
            <div className="frmgroup col-lg-2 dd_picker">
              <Dropdown
                options={
                  offcanvasState?.dropDownMenuOptions
                    ? offcanvasState.dropDownMenuOptions
                    : []
                }
                onChange={(selectedValue) => {
                  dispatch(setSelectedDdMenuValue(selectedValue));
                  offcanvasState.handleDdMenuChange(selectedValue);
                }}
                hideSelectedOptions={false}
                placeholder="Select Sprint"
                closeMenuOnSelect={true}
                defaultValue={offcanvasState.selectedValue}
              />
            </div>
          </div>
        )}
        {selectedData ? selectedData : <></>}
      </div>
    </CustomOffCanvas>
  );
};

export default memo(EmptyDrillDownOffCanvas);
EmptyDrillDownOffCanvas.propTypes = {
  customClass: PropTypes.number,
  subHeading: PropTypes.number,
};



